<template>
  <div class="notification-container">
    <NotificationBar
      v-for="notification in notification.notifications"
      :key="notification.id"
      :notification="notification"
    ></NotificationBar>
  </div>
</template>

<script>
import NotificationBar from '@/components/NotificationBar.vue'
import { mapState } from 'vuex'
export default {
  components: {
    NotificationBar
  },
  computed: {
    ...mapState(['notification'])
  }
}
</script>

<style>
.notification-container {
  position: fixed;
  bottom: 0;
  right: 0;
  padding-right: 40px;
  margin-top: 10px;
}
</style>
